/**
 * 内容相关
 * @type {number}
 */
// 栏目
export const COLUMN_STATUS_ONLINE = 1;
export const COLUMN_STATUS_OFFLINE = 2;
// 分组在线状态
export const CATEGORY_STATUS_ONLINE = 1;
export const CATEGORY_STATUS_OFFLINE = 2;
// 文章在线状态
export const ARTICLE_STATUS_ONLINE = 1;
export const ARTICLE_STATUS_OFFLINE = 2;
// 视频在线状态
export const VIDEO_STATUS_ONLINE = 1;
export const VIDEO_STATUS_OFFLINE = 2;

export const CONTENT_TYPE_ARTICLE = 1;
export const CONTENT_TYPE_CATEGORY = 2;
export const CONTENT_TYPE_VIDEO = 3;

/**
 * 广告位相关
 * @type {number}
 */
// 广告位跳转类型
export const BANNER_TARGET_TYPE_DEFAULT = 1;
export const BANNER_TARGET_TYPE_LINK = 2;
export const BANNER_TARGET_TYPE_ARTICLE = 3;
export const BANNER_TARGET_TYPE_MINI_PAGE = 4;
export const BANNER_TARGET_TYPE_CATEGORY = 5;
// 广告位在线状态
export const BANNER_STATUS_ONLINE = 1;
export const BANNER_STATUS_OFFLINE = 2;

/**
 * 页面（搭建）相关
 * @type {number}
 */
// 页面在线状态
export const PAGE_STATUS_ONLINE = 1;
export const PAGE_STATUS_OFFLINE = 2;
// 是否首页
export const PAGE_HOME_IS = 1;
export const PAGE_HOME_NOT = 2;

// 页面模块类型
export const PAGE_MODULE_TYPE_GALLERY = 1;
export const PAGE_MODULE_TYPE_KING_AREA = 2;
export const PAGE_MODULE_TYPE_SEARCH = 3;
export const PAGE_MODULE_TYPE_LIST = 4;
export const PAGE_MODULE_TYPE_VIDEO_LIST = 5;
export const PAGE_MODULE_TYPE_CIPIAN = 6;
export const PAGE_MODULE_TYPE_SPACE = 7;
export const PAGE_MODULE_TYPE_TEXT = 8;
export const PAGE_MODULE_TYPE_WEATHER = 9;

// 图片广告列表排列方式
export const PAGE_MODULE_GALLERY_LIST_TYPE_ONE_INLINE = 1;
export const PAGE_MODULE_GALLERY_LIST_TYPE_MULTI_INLINE = 2;
// 瓷片区排列方式
export const PAGE_MODULE_CIPIAN_LIST_TYPE_LEFT1_RIGHT2 = 1;
export const PAGE_MODULE_CIPIAN_LIST_TYPE_TOP1_BOTTOM2 = 2;
// 卡片列表排列方式
export const PAGE_MODULE_LIST_TYPE_ONE_INLINE_SMALL = 1;
export const PAGE_MODULE_LIST_TYPE_ONE_INLINE_BIG = 2;
export const PAGE_MODULE_LIST_TYPE_DOUBLE_INLINE = 3;
export const PAGE_MODULE_LIST_TYPE_MULTI_INLINE = 4;
export const PAGE_MODULE_LIST_TYPE_DOUBLE_INLINE_CONTENT_INNNER = 5;
export const PAGE_MODULE_LIST_TYPE_WATERFALL = 6;
// 视频列表排列方式
export const PAGE_MODULE_VIDEO_LIST_TYPE_ONE_INLINE_SMALL = 1;
export const PAGE_MODULE_VIDEO_LIST_TYPE_ONE_INLINE_BIG = 2;
export const PAGE_MODULE_VIDEO_LIST_TYPE_DOUBLE_INLINE = 3;
// 搜索框所在位置
export const PAGE_MODULE_SEARCH_POSITION_TYPE_DEFAULT = 1;
export const PAGE_MODULE_SEARCH_POSITION_TYPE_CUSTOMER = 2;
// 分类列表-显示内容描述
export const CATEGORY_LIST_SHOW_DESC_IS = 1;
export const CATEGORY_LIST_SHOW_DESC_NOT = 2;
  // 分类列表-显示点赞和关注
export const CATEGORY_LIST_SHOW_LIKE_COLLECT_IS = 1;
export const CATEGORY_LIST_SHOW_LIKE_COLLECT_NOT = 2;

// // 列表排列方式
// export const CATEGORY_LIST_TYPE_ONE_INLINE_SMALL = 1;
// export const CATEGORY_LIST_TYPE_ONE_INLINE_BIG = 2;
// export const CATEGORY_LIST_TYPE_DOUBLE_INLINE = 3;
// export const CATEGORY_LIST_TYPE_DOUBLE_INLINE_CONTENT_IN_COVER = 4;

export const ADMIN_TYPE_SUPER = 1;
export const ADMIN_TYPE_GENERAL = 2;

export const USER_SEX_MAN = 1;
export const USER_SEX_WOMEN = 2;
export const USER_SEX_UNKNOWN = 3;

// export const USER_VIP_IS = 1;
// export const USER_VIP_NOT = 2;

export const ROLE_SOURCE_DEFAULT = 1;
export const ROLE_SOURCE_CUSTOMER = 2;

export const PERMISSION_SOURCE_DEFAULT = 1;
export const PERMISSION_SOURCE_CUSTOMER = 2;

export const APPINFO_TYPE_WXMINI = 1;
export const APPINFO_TYPE_H5 = 2;
export const APPINFO_TYPE_ALIMINI = 3;

export const APPINFO_WX_MINI_UPLOAD_KEY_HAS = 1;
export const APPINFO_WX_MINI_UPLOAD_KEY_NOHAS = 2;

export const APPINFO_WX_APP_SECRET_HAS = 1;
export const APPINFO_WX_APP_SECRET_NOHAS = 2;

export const APPINFO_WX_APP_VERSION_UPDATED = 1;
export const APPINFO_WX_APP_VERSION_NOT_UPDATED = 2;
